export default __webpack_public_path__ + "static/media/invpagamentos.84c49d60.ico";